import {InputProps, useInput} from '@/hooks/useInput';
import HelperText from './shared/HelperText';
import ErrorText from './shared/ErrorText';
import {Label} from '@/shadcn_components/ui/label';
import {cn} from '@/lib/tailwind-utils';
import {ColorPicker} from '../basic/ColorPicker';

export type ColorPickerInputProps = InputProps & Partial<React.ComponentProps<'div'>>;

const ColorPickerInput = (props: ColorPickerInputProps) => {
  const {
    field: {value, ...restOfField},
    fieldState,
  } = useInput(props);

  return (
    <div className={cn('w-full space-y-1', props.className)}>
      <Label
      // className="text-lg"
      >
        {props.label}
      </Label>
      <ColorPicker
        type="rgba"
        color={String(value)}
        onChange={restOfField.onChange}
        className={props.disabled ? 'opacity-50 pointer-events-none' : ''}
      />
      <HelperText helperText={props.helperText} />
      <ErrorText {...fieldState} />
    </div>
  );
};

export default ColorPickerInput;
